<template>
  <div
    class="fixed top-0 left-0 w-screen h-screen z-[100001] opacity-0 pointer-events-none transition-all duration-500"
    :class="{ 'opacity-100 pointer-events-auto': modalsStore.isInfoModalVisible }">
    <div
      class="absolute top-0 left-0 w-full h-full z-10 opacity-70 bg-black backdrop-blur-lg"
      @click="modalsStore.hideInfoModal"></div>
    <div
      class="absolute inset-0 z-20 flex items-center justify-center p-5 pointer-events-none">
      <div
        class="relative w-full max-w-xl max-h-full scale-0 overflow-y-auto rounded-2xl bg-white pointer-events-auto transition-all duration-500"
        :class="{ 'scale-100': modalsStore.isInfoModalVisible }">
        <div
          class="absolute top-2 right-2 z-10 cursor-pointer group"
          @click="modalsStore.hideInfoModal">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="block w-5 h-auto">
            <path
              d="M22.9999 1.35556L1.00132 23.3542"
              stroke="#553F3F"
              stroke-width="2"
              stroke-linecap="round"
              class="transition-all duration-300 group-hover:stroke-base-color" />
            <path
              d="M22.9999 23.3554L1.00132 1.35678"
              stroke="#553F3F"
              stroke-width="2"
              stroke-linecap="round"
              class="transition-all duration-300 group-hover:stroke-base-color" />
          </svg>
        </div>

        <div class="w-full p-6 flex flex-col gap-3">
          <div
            v-if="modalsStore.infoModalTitle"
            class="w-full text-xl font-semibold text-black">
            {{ modalsStore.infoModalTitle }}
          </div>

          <div
            v-if="modalsStore.infoModalMessage"
            class="w-full text-base text-black"
            v-html="modalsStore.infoModalMessage"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useModalsStore from '@/store/modals';

const modalsStore = useModalsStore();
</script>
